import dayjs from "dayjs";
import getTimestamp from "./plugins/getTimestamp";
import toLocale from "./plugins/toLocale";

(function () {
  dayjs.extend(getTimestamp, {});
  dayjs.extend(toLocale, {});
})();

const setLocale = (locale) => {
  let objectLang = null;
  if ("zh-cn" === locale) {
    objectLang = require("dayjs/locale/zh-cn");
  } else if ("vi" === locale) {
    objectLang = require("dayjs/locale/vi");
  } else if ("id" === locale) {
    objectLang = require("dayjs/locale/id");
  } else if ("ms" === locale) {
    objectLang = require("dayjs/locale/ms");
  } else if ("de" === locale) {
    objectLang = require("dayjs/locale/de");
  } else if ("es" === locale) {
    objectLang = require("dayjs/locale/es");
  } else {
    objectLang = require("dayjs/locale/en");
  }
  if (!objectLang) return;
  dayjs.locale(locale, objectLang);
};

export { setLocale };
